var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5769 0.180725C20.0852 0.180725 20.4973 0.592806 20.4973 1.10112V15.8336C20.4973 16.3385 20.0782 16.7479 19.5844 16.7479H3.00218C2.49803 16.7479 2.08933 16.3384 2.08933 15.8336V14.9071H18.6565V4.13844L11.2933 10.7653L2.08933 2.48172V1.10112C2.08933 0.592806 2.50141 0.180725 3.00973 0.180725H19.5769ZM7.61172 11.2255V13.0663H0.248535V11.2255H7.61172ZM4.85052 6.62351V8.46431H0.248535V6.62351H4.85052ZM18.257 2.02152H4.32971L11.2933 8.28879L18.257 2.02152Z",
    fill: "#086AD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.568f98a98465318ead0bb6ac0c658295.svg";
export { ForwardRef as ReactComponent };